import { VIDEO_TOPIC_ICON } from '~/bootcamp/constants/bootcamp.const'

import { CategoryPathUrls } from '~/bootcamp/types/bootcamp.types'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface TopicProp {
  topicKey: CategoryPathUrls
  className?: string
  iconResTimes?: number // To enlarge the icon
}

const VideoTopicIcon = ({ topicKey, iconResTimes = 1 }: TopicProp): React.ReactElement => {
  const icon = VIDEO_TOPIC_ICON[topicKey]
  const mediaQuery = [{ screen: '(min-width: 280px)', width: `${icon.width * iconResTimes}px` }]
  return (
    <div>
      <ResponsiveImage
        alt={topicKey.replace(/-/g, ' ')}
        height={icon.height * iconResTimes}
        imageClassName="mx-auto"
        imageWidths={`${icon.width * iconResTimes}`}
        mediaQuery={mediaQuery}
        srcKey={icon.srcKey}
        width={icon.width * iconResTimes}
      />
    </div>
  )
}

export default VideoTopicIcon
